
import React from "react";
import { Route, Switch, useLocation, Redirect } from "react-router-dom";
// javascript plugin used to create scrollbars on windows

// core components
import RTLNavbar from "../components/Navbars/RTLNavbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

import routes from "../routes.js";
import { BackgroundColorContext } from "../contexts/BackgroundColorContext";
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'
import Loading from '../Helper/Loading.js'
import Particles from "../components/Particle";

function RTL(props) {

    const [IsLoading, setIsLoading] = React.useState(true);
    const [siteSetting, setsiteSetting] = React.useState({});
    const location = useLocation();
    const mainPanelRef = React.useRef(null);
    const [sidebarOpened, setsidebarOpened] = React.useState(
        document.documentElement.className.indexOf("nav-open") !== -1
    );

    React.useEffect(() => {

        let head = document.head;
        let meta1 = document.createElement("meta");
        let meta2 = document.createElement("meta");
        meta1.name = "description";
        meta2.name = "keywords";

        const config = {
            method: "Post",
            url: "User/GetUserSiteSetting",
            Authorization: true,
            data: {}
        }

        apiCall(config, (response) => {

            setIsLoading(false);
            if (response.data.Result.SiteHeader == null ||
                response.data.Result.SiteHeader === "") {
                response.data.Result.SiteHeader = "سامانه پرداخت الکترونیکی عوارض"
            }
   
            setsiteSetting(response.data.Result);
            meta1.content=response.data.Result.DescriptionMeta;
            meta2.content=response.data.Result.KeywordsMeta;
            head.appendChild(meta1);
            head.appendChild(meta2);
        }, (err) => {
            console.log(err)
            Swal.fire({
                title: 'عملیات ناموفق',
                text: err,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        });
    // eslint-disable-next-line
    },[]);

    React.useEffect(() => {
        // on this page, we need on the body tag the classes .rtl and .menu-on-right
        document.body.classList.add("rtl", "menu-on-right");
        // we also need the rtl bootstrap
        // so we add it dynamically to the head
        let head = document.head;
        let link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "rtl-id";
        link.href =
            "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css";
        head.appendChild(link);
        // Specify how to clean 

        document.title = getBrandText(location.pathname);
        // Specify how to clean up after this effect:
        return function cleanup() {
            // when we exit this page, we need to delete the classes .rtl and .menu-on-right
            // from the body tag
            document.body.classList.remove("rtl", "menu-on-right");
            // we also need to delete the rtl bootstrap, so it does not break the other pages
            // that do not make use of rtl
            document.getElementById("rtl-id").remove();
        };
    });

    // this function opens and closes the sidebar on small devices
    const toggleSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        setsidebarOpened(!sidebarOpened);
    };

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            return (
                <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                />
                
            );
        });
    };

    const getBrandText = (path) => {
        for (let i = 0; i < routes.length; i++) {
          if (location.pathname.indexOf(routes[i].path) !== -1) {
            return  siteSetting.SiteTitle+" | "+routes[i].rtlName;
          }
        }
        return "سامانه پرداخت الکترونیکی عوارض";
      };


    if (IsLoading) {
        return (
            <>
                <div className="main-panel" ref={mainPanelRef}>
                    <Loading />
                </div>
            </>
        )
    }
    else {
        return (
            <>
                <BackgroundColorContext.Consumer>
                    {({ color, changeColor }) => (
                        <>
                            <RTLNavbar
                                siteHeader={siteSetting.SiteHeader}
                                siteTitle={siteSetting.SiteTitle}
                                siteLogoUrl={siteSetting.HeaderLogoUrl}
                                toggleSidebar={toggleSidebar}
                                sidebarOpened={sidebarOpened}
                            
                            />

                            <div className="wrapper">
                                <Sidebar
                                    routes={routes}
                                    toggleSidebar={toggleSidebar}
                                    Enamad={siteSetting.Enamad}
                                />

                                <div className="main-panel" ref={mainPanelRef} data={color}>
                                <Particles />
                                    <Switch>
                                        {getRoutes(routes)}
                                        <Redirect from="*" to="/Payment" />
                                    </Switch>

                                    <Footer 
                                    siteSetting={siteSetting}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </BackgroundColorContext.Consumer>
            </>
        );
    }


}


export default RTL;
